export const getBotsSkillsOrder = (state) => state.botsRoute.skills.order;
export const getBotsSkillsOrderBy = (state) => state.botsRoute.skills.orderBy;
export const getBotsSkillsPage = (state) => state.botsRoute.skills.page;
export const getBotsSkillsSearch = (state) => state.botsRoute.skills.search;
export const getBotsSkillsTotal = (state) => state.botsRoute.skills.total;
export const getBotsSkillsFilters = (state) => state.botsRoute.skills.filters;

export const getBotsSkills = (state) =>
  state.botsRoute.skills.ids.map((id) => state.botsRoute.skillsById[id]);

export const getBotsSkillsTagChoices = (state) =>
  state.bot_tags.ids.map((id) => {
    const tag = state.bot_tags.byId[id];
    return { label: tag.name, value: tag.id };
  });
